/** Which frame the shell is drawn for — the two views every option is shown in. */
export enum Viewport {
  DESKTOP = 'DESKTOP',
  MOBILE = 'MOBILE',
}

/** Which edge a docked agent panel takes. Gemini docks right, HubSpot docks left. */
export enum PanelSide {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export const DEFAULT_ORG_NAME = 'Blueline Freight'

/** Muse names its avatar, which is what turns the agent into someone rather than something. */
export const AGENT_NAME = 'Bluey'

/** What the newest sections call the Artifacts surface. */
export const ARTIFACTS_LABEL = 'Charts'
